const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const IMPERSONATION_ORIGINAL_TOKEN_KEY = 'impersonation_original_token'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
  getToken () {
    return localStorage.getItem(TOKEN_KEY)
  },

  saveToken (accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },

  removeToken () {
    localStorage.removeItem(TOKEN_KEY)
  },

  getRefreshToken () {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  saveRefreshToken (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  },

  removeRefreshToken () {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  isImpersonating () {
    return !!localStorage.getItem(IMPERSONATION_ORIGINAL_TOKEN_KEY)
  },

  saveOriginalToken (token) {
    localStorage.setItem(IMPERSONATION_ORIGINAL_TOKEN_KEY, token)
  },

  getOriginalToken () {
    return localStorage.getItem(IMPERSONATION_ORIGINAL_TOKEN_KEY)
  },

  removeOriginalToken () {
    localStorage.removeItem(IMPERSONATION_ORIGINAL_TOKEN_KEY)
  }

}

export { TokenService }
